import { ReactNode } from "react";

export function Card({ children }: { children: ReactNode }) {
  return <div className="w-full p-5 border rounded-lg">{children}</div>;
}
